export const notification_types = {
  task_status: 'task_status',
  task_plandate: 'task_plandate',
  task_assign: 'task_assign',
  task_comment: 'task_comment',
  task_document: 'task_document',
  order_assign: 'order_assign',
}
